import type { RouteRecordRaw } from 'vue-router';

import { toDownloadAccountId } from '@/modules/movements/utils/movementsDownloadRoute.util';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const Movements = () => import('@/modules/movements/pages/Movements/index.vue');
const MovementsDownloadView = () => import('@/modules/movements/views/MovementsDownloadView/index.vue');

const movementsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/movement-list',
    name: 'movements-section',
    redirect: {
      name: 'movements-view',
    },
    meta: {
      title: 'Movimientos',
      subTitle: 'last-connection',
      accessRol: {
        section: 'TRANSACTIONS',
        actions: ['VIEW_TRANSACTIONS'],
      },
    },
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'movements-view',
        component: Movements,
      },
      {
        path: '/movement-list/downloads',
        name: 'movements-download',
        component: MovementsDownloadView,
        props: (route) => ({ initialAccountId: toDownloadAccountId(route.query.walletId) }),
        meta: {
          accessRol: {
            section: 'TRANSACTIONS',
            actions: ['DOWNLOAD_DOCUMENTS'],
          },
        },
      },
    ],
  },
];

export default movementsRoutes;
